export default "__VITE_ASSET__CDi2LwOE__"